export const downloadFile = (file, fileName) => {
  const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
}

export const previewFile = (file, fileName) => {
  const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
  const link = document.createElement('a')
  link.href = url
  link.target = '_blank'
  link.setAttribute('value', fileName)
  document.body.appendChild(link)
  link.click()
}
